import { FareEstimateSecureApiModel } from '../api-models/FareEstimateSecureApiModel';
import { FareEstimateSecure } from '../entities/FareEstimateSecure';

export function toFareEstimateSecureResponse(
  response: FareEstimateSecureApiModel,
): FareEstimateSecure {
  return {
    token: response.response.fare_estimate_token,
  };
}
